import { Box, IconButton, styled, Tooltip } from '@mui/material';
import { CardContainer } from 'DesignSystem';
import Icon from 'DesignSystem/Primitives/Icon/Icon';
import React, { FC, MouseEvent } from 'react';
import { IPlot } from 'FeatureModules/Site/types/plot.types';
import PlotTitle from './PlotTitle';
import FlexBox from 'Components/FlexBox';
import {
  EGeoDataIssueSeverityLevel,
  IGeoDataIssue,
} from 'FeatureModules/DataImport/types/dataset.types';

interface IPlotItemProps {
  issues?: IGeoDataIssue[];
  hideSeverity?: boolean;
  plot: IPlot;
  onClick?: (plot: IPlot) => void;
  onEdit?: (plot: IPlot) => void;
  onDelete?: (plot: IPlot) => void;
}

const StyledCardContainer = styled(CardContainer)(() => ({
  maxWidth: '100%',
}));

const PlotItemContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  maxWidth: '100%',

  '&:not(:last-child)': {
    marginBottom: theme.spacing(1),
  },
}));

const PlotItem: FC<IPlotItemProps> = ({
  plot,
  issues,
  hideSeverity,
  onClick,
  onEdit,
  onDelete,
}) => {
  const warnings =
    issues?.filter(issue => issue.severityLevel === EGeoDataIssueSeverityLevel.WARNING) || [];

  const errors =
    issues?.filter(issue => issue.severityLevel === EGeoDataIssueSeverityLevel.ERROR) || [];

  const handleEdit = (event: MouseEvent) => {
    event.stopPropagation();
    onEdit?.(plot);
  };
  const handleDelete = (event: MouseEvent) => {
    event.stopPropagation();
    onDelete?.(plot);
  };
  return (
    <PlotItemContainer key={plot.id} display="flex" alignItems="center" gap={1}>
      {!hideSeverity && (
        <FlexBox>
          {!errors.length && !warnings.length && (
            <Icon name="check-filled" size="large" color="green" />
          )}
          {!!errors.length && <Icon name="error-filled" size="large" color="red" />}
          {!!warnings.length && !errors.length && (
            <Icon name="info-filled" size="large" color="yellow" />
          )}
        </FlexBox>
      )}

      <StyledCardContainer padding={1.5} blueHover={!!onClick} onClick={() => onClick?.(plot)}>
        <FlexBox maxWidth="100%" justifyContent="space-between">
          {/*  48px for the action button container & 24px padding */}
          <Box width="calc(100% - 48px - 24px)" textOverflow="ellipsis" overflow="hidden">
            <PlotTitle
              plot={plot}
              errors={hideSeverity ? [] : errors}
              warnings={hideSeverity ? [] : warnings}
            />
          </Box>

          <FlexBox gap={0.5} mr={1}>
            {onEdit && (
              <Tooltip title="Edit plot">
                <IconButton onClick={handleEdit}>
                  <Icon name="edit" size="medium" />
                </IconButton>
              </Tooltip>
            )}
            {onDelete && (
              <Tooltip title="Delete plot">
                <IconButton onClick={handleDelete}>
                  <Icon name="delete" size="medium" />
                </IconButton>
              </Tooltip>
            )}
          </FlexBox>
        </FlexBox>
      </StyledCardContainer>
    </PlotItemContainer>
  );
};

export default PlotItem;
